import { render, staticRenderFns } from "./TextState.vue?vue&type=template&id=98880882&"
import script from "./TextState.vue?vue&type=script&lang=js&"
export * from "./TextState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports